import Button from "@mui/material/Button";
import { IPropsWithStyle } from "./types/button";

const ButtonComponent = ({
  label,
  onClick,
  disabled = false,
  className,
  startIcon,
  color,
  ...otherProps
}: IPropsWithStyle & { startIcon?: React.ReactNode }) => {
  return (
    <Button
      onClick={onClick}
      disabled={disabled}
      className={className}
      startIcon={startIcon}
      {...otherProps}
    >
      {label}
    </Button>
  );
};

export default ButtonComponent;
